import { BaseReducerState, Bill, Response } from '../../../services'
import { ActionTypes } from '../actions'

export interface ReopenAccountAPIResponse extends Response {
  data: Bill
}

export type ReopenAccountState = BaseReducerState & {
  data: Bill
}

const reopenAccountInitialState: ReopenAccountState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const reopenAccount = (
  state: ReopenAccountState = reopenAccountInitialState,
  action: { type: string; res: any }
): ReopenAccountState => {
  switch (action.type) {
    case `${ActionTypes.REOPEN_ACCOUNT}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.REOPEN_ACCOUNT}_SUCCESS`: {
      const { success, data, message } = <ReopenAccountAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.REOPEN_ACCOUNT}_FAILURE`:
      const res = <ReopenAccountAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.REOPEN_ACCOUNT}_RESET`:
      return {
        ...state,
        loading: false,
        success: false,
        message: null,
        data: null,
        error: null,
      }
  }
  return state
}
